import { render, staticRenderFns } from "./SidebarV2.ts.vue?vue&type=template&id=50e1d19c"
import script from "./SidebarV2.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarV2.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarV2.ts.vue?vue&type=style&index=0&id=50e1d19c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports